// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAFvpFw9qznoNMVz4cDzPlU2zP-tCihRbY",
  authDomain: "sardoretto-7ffb4.firebaseapp.com",
  databaseURL:
    "https://sardoretto-7ffb4-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "sardoretto-7ffb4",
  storageBucket: "sardoretto-7ffb4.appspot.com",
  messagingSenderId: "48160974297",
  appId: "1:48160974297:web:f0d3a5de374c6efc7de5c8",
  measurementId: "G-ZY16PL58CL",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
